import { IDefaultProfileScoreCategory } from '../../../../interfaces/gamification.interface';

export const defaultProfileScoreCategoriesData: IDefaultProfileScoreCategory[] =
  [
    {
      name: 'Basic Profile Information',
      icon: null,
      link: '/profile#personal-info',
      buttonText: 'Edit Profile',
    },
    {
      name: 'Sports History Details',
      icon: null,
      link: null,
      buttonText: null,
    },
    {
      name: 'Profile Picture',
      icon: null,
      link: '/profile#personal-info',
      buttonText: 'Edit Profile',
    },
    {
      name: 'Cover Photo',
      icon: null,
      link: null,
      buttonText: null,
    },
    {
      name: 'Sending Connection Requests',
      icon: null,
      link: null,
      buttonText: null,
    },
    {
      name: 'Accepting Connection Requests',
      icon: null,
      link: null,
      buttonText: null,
    },
    {
      name: 'Inviting New Athletes',
      icon: null,
      link: null,
      buttonText: null,
    },
    {
      name: 'Creating a Post',
      icon: null,
      link: null,
      buttonText: null,
    },
    {
      name: 'Commenting on Posts',
      icon: null,
      link: null,
      buttonText: null,
    },
    {
      name: 'Liking or Sharing a Post',
      icon: null,
      link: null,
      buttonText: null,
    },
    {
      name: 'Feedback',
      icon: null,
      link: null,
      buttonText: null,
    },
  ];
